import router from "@/router";
import { RouteParamsRaw, useRoute } from "vue-router";
import {Crumb} from "@/types/navigation";

class RouterService {
  async routeTo(name: string, params: RouteParamsRaw = {}) {
    await router.push({ name: name, params: params });
  }

  getBreadCrumbs(): Crumb[] {
    const current = router.currentRoute.value;

    const raw: Crumb[] = current.matched
      .filter(r => r.name && !r.meta?.breadcrumbIgnore)
      .map(r => ({
        routeName: (r.meta?.crumbTo as string) || String(r.name),
        labelKey:  (r.meta?.crumb   as string) || String(r.name)
      }));

    const dedup: Crumb[] = [];
    for (const c of raw) {
      const last = dedup[dedup.length - 1];
      if (last && (last.labelKey === c.labelKey || last.routeName === c.routeName)) continue;
      dedup.push(c);
    }

    const audience = current.matched.find(r => r.meta?.audience)?.meta.audience as "guest" | "admin" | undefined;
    const homeCrumb: Crumb =
      audience === "admin"
        ? { routeName: "reservation-home", labelKey: "reservation-home" }
        : { routeName: "home",              labelKey: "home" };

    if (!dedup.length || dedup[0].routeName !== homeCrumb.routeName) {
      dedup.unshift(homeCrumb);
    }

    return dedup;
  }

  getLoginParameter() {
    return this.getQueryParams().login?.toString() ?? "";
  }

  refreshCurrentPage() {
    router.go(0);
  }

  getQueryParams() {
    const route = useRoute();
    return route.query;
  }

  getCurrentRouteName(): string {
    return router.currentRoute.value.name?.toString() ?? "";
  }
}

export default new RouterService();
